import { render, staticRenderFns } from "./ReservationPreorderDetail.vue?vue&type=template&id=24f74a79&lang=pug&"
import script from "./ReservationPreorderDetail.vue?vue&type=script&lang=js&"
export * from "./ReservationPreorderDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports